import { render, staticRenderFns } from "./ViewingAppointmentsTab.vue?vue&type=template&id=49940e22&scoped=true"
import script from "./ViewingAppointmentsTab.vue?vue&type=script&lang=js"
export * from "./ViewingAppointmentsTab.vue?vue&type=script&lang=js"
import style0 from "./ViewingAppointmentsTab.vue?vue&type=style&index=0&id=49940e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49940e22",
  null
  
)

export default component.exports